// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'


import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.use(VueFire)
Vue.use(Vuetify)
Vue.use(Vuelidate)

// Initialize Firebase
var config = {
    apiKey: "AIzaSyAUDCnut94cm1w04r0HTcjjZDpSaJcXD4o",
    authDomain: "pec-dmv.firebaseapp.com",
    databaseURL: "https://pec-dmv.firebaseio.com",
    projectId: "pec-dmv",
    storageBucket: "pec-dmv.appspot.com",
    messagingSenderId: "1055532404430"
}
// firebase.initializeApp(config)
export const db = firebase.firestore()

let app;

/* eslint-disable no-new */
firebase.auth().onAuthStateChanged((user) => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            components: { App },
            template: '<App/>'
        })
    }
})



// WEBPACK FOOTER //
// ./src/main.js